module.exports = __webpack_public_path__ + "img/84.7.Chla.fd471dfa.png";